// BAIQL template catalog

export const BAIQL_TEMPLATES = [
  {
    id: 'student-grading',
    name: 'Student Paper Grading',
    category: 'Grading with Rubric',
    batchType: 'COMBO*',
    description: 'Grade student papers using a rubric (CSV variables + one reference + work files).',
    code: `# Student Paper Grading (COMBO*)
GLOBAL PATH_IN /data/input/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  # Variable data (students)
  LOAD student_info.csv AS FILE

  # Reference rubric (auto-cached)
  LOAD grading_rubric.pdf AS REF

  # Papers to grade
  LOAD papers/ AS WORK

  # Prompt with variables from FILE
  PROMPT "Grade {student_name}'s paper in section {section}. Justify scores for each rubric item."
  RUN

  # One result per paper
  OUTPUT grades/{student_id}.json FORMAT json SEPARATE
END_BATCH
`
  },
  {
    id: 'email-generation',
    name: 'Email Generation from CSV',
    category: 'Content Generation',
    batchType: 'PROMPT',
    description: 'Generate personalized emails using variables from a CSV.',
    code: `# Email Generation (PROMPT)
GLOBAL PATH_IN /data/input/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  LOAD customers.csv AS FILE
  PROMPT "Write a concise outreach email to {name} about product {product}. Keep tone friendly and professional."
  RUN
  OUTPUT emails/{name}.txt FORMAT txt SEPARATE
END_BATCH
`
  },
  {
    id: 'resume-screening',
    name: 'Resume Screening',
    category: 'Document Analysis',
    batchType: 'EXAMINE',
    description: 'Screen resumes in a directory and extract key qualifications.',
    code: `# Resume Screening (EXAMINE)
GLOBAL PATH_IN /data/resumes/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  LOAD resumes/ AS WORK
  PROMPT "Summarize candidate's top 5 qualifications and overall fit score (0-10)."
  RUN
  OUTPUT summaries/{FILENAME}.json FORMAT json MATCH
END_BATCH
`
  },
  {
    id: 'document-summarization',
    name: 'Document Summarization',
    category: 'Document Analysis',
    batchType: 'EXAMINE',
    description: 'Summarize each document into key points and action items.',
    code: `# Document Summarization (EXAMINE)
GLOBAL PATH_IN /data/docs/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  LOAD docs/ AS WORK
  PROMPT "Provide a 5-bullet summary and 3 recommended actions."
  RUN
  OUTPUT summaries/{FILENAME}.md FORMAT txt MATCH
END_BATCH
`
  },
  {
    id: 'contract-analysis',
    name: 'Contract Analysis',
    category: 'Custom Analysis',
    batchType: 'COMBO',
    description: 'Analyze contracts using variable data and reference clauses.',
    code: `# Contract Analysis (COMBO)
GLOBAL PATH_IN /data/input/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  LOAD clients.csv AS FILE
  LOAD clauses.pdf AS REF
  LOAD contracts/ AS WORK
  PROMPT "Analyze {client_name}'s contract for liability, termination, and IP clauses compared to reference."
  RUN
  OUTPUT reports/{client_id}_{FILENAME}.md FORMAT txt SEPARATE
END_BATCH
`
  },
  {
    id: 'multi-step-pipeline',
    name: 'Multi-step Processing Pipeline',
    category: 'Multi-step Processing',
    batchType: 'CHAIN',
    description: 'Process files in multiple steps: outline → draft → polish.',
    code: `# Multi-step Processing (CHAIN)
GLOBAL PATH_IN /data/work/
GLOBAL PATH_OUT /data/output/

BATCH_START EXECUTE
  LOAD articles/ AS WORK

  STEP 1 PROMPT "Create a detailed outline for the document"
  RUN
  OUTPUT outlines/{FILENAME}.json FORMAT json SEPARATE

  STEP 2 PROMPT "Write a 800-word draft from the outline"
  RUN
  OUTPUT drafts/{FILENAME}.txt FORMAT txt SEPARATE

  STEP 3 PROMPT "Polish the draft for clarity and grammar"
  RUN
  OUTPUT polished/{FILENAME}.txt FORMAT txt SEPARATE
END_BATCH
`
  }
];


